import React, { useState } from 'react';
import { SearchIcon, FilterIcon, CheckCircleIcon, ClockIcon, AlertCircleIcon, StarIcon, BarChart3Icon, FileTextIcon, ListIcon, EyeIcon, ChevronDownIcon, ChevronUpIcon, TrendingDownIcon, TrendingUpIcon, InfoIcon } from 'lucide-react';
import Card from '../components/Card';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
const RatingAgencyPortal = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedApplication, setExpandedApplication] = useState<string | null>(null);
  const toggleApplicationDetails = (id: string) => {
    if (expandedApplication === id) {
      setExpandedApplication(null);
    } else {
      setExpandedApplication(id);
    }
  };
  return <div className="max-w-6xl mx-auto" data-id="element-2490">
      <div className="mb-6" data-id="element-2491">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-2492">
          Rating Agency Portal
        </h1>
        <p className="text-neutral-400" data-id="element-2493">
          Assess and rate micro-sukuk applications for risk classification
        </p>
      </div>
      {/* Dashboard Overview */}
      <section className="mb-8" data-id="element-2494">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2495">
          <Card data-id="element-2496">
            <div className="flex items-center mb-2" data-id="element-2497">
              <div className="w-10 h-10 rounded-full bg-warning bg-opacity-10 flex items-center justify-center mr-3" data-id="element-2498">
                <ClockIcon className="w-5 h-5 text-warning" data-id="element-2499" />
              </div>
              <div data-id="element-2500">
                <h3 className="font-medium" data-id="element-2501">Pending Assessment</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-2502">5</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-2503">
              Awaiting risk rating
            </div>
          </Card>
          <Card data-id="element-2504">
            <div className="flex items-center mb-2" data-id="element-2505">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-2506">
                <CheckCircleIcon className="w-5 h-5 text-success" data-id="element-2507" />
              </div>
              <div data-id="element-2508">
                <h3 className="font-medium" data-id="element-2509">Completed</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-2510">32</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-2511">Last 30 days</div>
          </Card>
          <Card data-id="element-2512">
            <div className="flex items-center mb-2" data-id="element-2513">
              <div className="w-10 h-10 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-3" data-id="element-2514">
                <TrendingDownIcon className="w-5 h-5 text-success" data-id="element-2515" />
              </div>
              <div data-id="element-2516">
                <h3 className="font-medium" data-id="element-2517">Low Risk</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-2518">68%</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-2519">
              Of rated applications
            </div>
          </Card>
          <Card data-id="element-2520">
            <div className="flex items-center mb-2" data-id="element-2521">
              <div className="w-10 h-10 rounded-full bg-warning bg-opacity-10 flex items-center justify-center mr-3" data-id="element-2522">
                <TrendingUpIcon className="w-5 h-5 text-warning" data-id="element-2523" />
              </div>
              <div data-id="element-2524">
                <h3 className="font-medium" data-id="element-2525">Medium Risk</h3>
              </div>
            </div>
            <div className="text-2xl font-bold" data-id="element-2526">26%</div>
            <div className="text-xs text-neutral-400 mt-1" data-id="element-2527">
              Of rated applications
            </div>
          </Card>
        </div>
      </section>
      {/* Application Management */}
      <section className="mb-8" data-id="element-2528">
        <Card data-id="element-2529">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6" data-id="element-2530">
            <h2 className="text-xl font-bold" data-id="element-2531">Micro-Sukuk Applications</h2>
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-2 mt-3 md:mt-0 w-full md:w-auto" data-id="element-2532">
              <div className="relative" data-id="element-2533">
                <input type="text" placeholder="Search applications..." className="pl-9 pr-4 py-2 border border-neutral-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary w-full md:w-auto" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2534" />
                <SearchIcon className="w-4 h-4 absolute left-3 top-3 text-neutral-400" data-id="element-2535" />
              </div>
              <Button variant="outline" icon={<FilterIcon className="w-4 h-4" data-id="element-2537" />} iconPosition="left" data-id="element-2536">
                Filter
              </Button>
            </div>
          </div>
          {/* Tabs */}
          <div className="mb-4 border-b border-neutral-200" data-id="element-2538">
            <div className="flex overflow-x-auto -mb-px" data-id="element-2539">
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'pending' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('pending')} data-id="element-2540">
                Pending Assessment (5)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'in-progress' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('in-progress')} data-id="element-2541">
                In Progress (3)
              </button>
              <button className={`py-2 px-4 font-medium text-sm whitespace-nowrap ${activeTab === 'completed' ? 'border-b-2 border-primary text-primary' : 'text-neutral-400 hover:text-neutral-600'}`} onClick={() => setActiveTab('completed')} data-id="element-2542">
                Completed (32)
              </button>
            </div>
          </div>
          {/* Applications List */}
          <div className="space-y-4" data-id="element-2543">
            {/* Application Item 1 */}
            <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-2544">
              <div className="flex flex-col md:flex-row md:items-center justify-between p-4 cursor-pointer hover:bg-neutral-50" onClick={() => toggleApplicationDetails('MS2023-104')} data-id="element-2545">
                <div className="flex-1" data-id="element-2546">
                  <div className="flex items-center mb-2" data-id="element-2547">
                    <h3 className="font-medium mr-2" data-id="element-2548">Amani Cafe</h3>
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs" data-id="element-2549">
                      Pending Assessment
                    </span>
                  </div>
                  <div className="text-sm text-neutral-400 flex flex-wrap gap-x-4" data-id="element-2550">
                    <span data-id="element-2551">ID: MS2023-104</span>
                    <span data-id="element-2552">Equipment Purchase</span>
                    <span data-id="element-2553">RM 25,000</span>
                    <span data-id="element-2554">Received: 2 days ago</span>
                  </div>
                </div>
                <div className="flex items-center mt-3 md:mt-0" data-id="element-2555">
                  <Link to="/dashboard/rating-assessment" data-id="element-2556">
                    <Button variant="primary" size="sm" className="mr-2" data-id="element-2557">
                      Begin Assessment
                    </Button>
                  </Link>
                  {expandedApplication === 'MS2023-104' ? <ChevronUpIcon className="w-5 h-5 text-neutral-400" data-id="element-2558" /> : <ChevronDownIcon className="w-5 h-5 text-neutral-400" data-id="element-2559" />}
                </div>
              </div>
              {expandedApplication === 'MS2023-104' && <div className="border-t border-neutral-100 p-4 bg-neutral-50" data-id="element-2560">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2561">
                    <div data-id="element-2562">
                      <h4 className="font-medium mb-3" data-id="element-2563">Business Information</h4>
                      <div className="space-y-3" data-id="element-2564">
                        <div className="flex justify-between" data-id="element-2565">
                          <span className="text-sm text-neutral-400" data-id="element-2566">
                            Business Name
                          </span>
                          <span className="text-sm font-medium" data-id="element-2567">
                            Amani Cafe
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2568">
                          <span className="text-sm text-neutral-400" data-id="element-2569">
                            Registration No.
                          </span>
                          <span className="text-sm font-medium" data-id="element-2570">
                            BRN-1234567-A
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2571">
                          <span className="text-sm text-neutral-400" data-id="element-2572">
                            Years in Operation
                          </span>
                          <span className="text-sm font-medium" data-id="element-2573">
                            3 years, 4 months
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2574">
                          <span className="text-sm text-neutral-400" data-id="element-2575">
                            Monthly Revenue
                          </span>
                          <span className="text-sm font-medium" data-id="element-2576">RM 45,000</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2577">
                          <span className="text-sm text-neutral-400" data-id="element-2578">
                            Credit Score
                          </span>
                          <span className="text-sm font-medium text-success" data-id="element-2579">
                            Excellent (85/100)
                          </span>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-2580">
                      <h4 className="font-medium mb-3" data-id="element-2581">Financing Request</h4>
                      <div className="space-y-3" data-id="element-2582">
                        <div className="flex justify-between" data-id="element-2583">
                          <span className="text-sm text-neutral-400" data-id="element-2584">
                            Purpose
                          </span>
                          <span className="text-sm font-medium" data-id="element-2585">
                            Equipment Purchase
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2586">
                          <span className="text-sm text-neutral-400" data-id="element-2587">
                            Amount Requested
                          </span>
                          <span className="text-sm font-medium" data-id="element-2588">RM 25,000</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2589">
                          <span className="text-sm text-neutral-400" data-id="element-2590">
                            Duration
                          </span>
                          <span className="text-sm font-medium" data-id="element-2591">6 months</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2592">
                          <span className="text-sm text-neutral-400" data-id="element-2593">
                            Monthly Payment
                          </span>
                          <span className="text-sm font-medium" data-id="element-2594">RM 4,271</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2595">
                          <span className="text-sm text-neutral-400" data-id="element-2596">
                            Total Profit
                          </span>
                          <span className="text-sm font-medium" data-id="element-2597">
                            RM 2,250 (18% p.a.)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-4 p-3 bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg" data-id="element-2598">
                    <div className="flex items-start" data-id="element-2599">
                      <InfoIcon className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" data-id="element-2600" />
                      <div data-id="element-2601">
                        <h5 className="text-sm font-medium text-primary mb-1" data-id="element-2602">
                          Digital Advisor Notes
                        </h5>
                        <p className="text-sm text-neutral-500" data-id="element-2603">
                          Amani Cafe's application is complete and meets all
                          eligibility criteria. The business has strong
                          financials and the equipment purchase aligns with
                          their growth strategy. The espresso machine will help
                          increase revenue and the community benefits offered
                          are appropriate.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
            {/* Application Item 2 */}
            <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-2604">
              <div className="flex flex-col md:flex-row md:items-center justify-between p-4 cursor-pointer hover:bg-neutral-50" onClick={() => toggleApplicationDetails('MS2023-103')} data-id="element-2605">
                <div className="flex-1" data-id="element-2606">
                  <div className="flex items-center mb-2" data-id="element-2607">
                    <h3 className="font-medium mr-2" data-id="element-2608">GreenTech Solutions</h3>
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs" data-id="element-2609">
                      Pending Assessment
                    </span>
                  </div>
                  <div className="text-sm text-neutral-400 flex flex-wrap gap-x-4" data-id="element-2610">
                    <span data-id="element-2611">ID: MS2023-103</span>
                    <span data-id="element-2612">Inventory</span>
                    <span data-id="element-2613">RM 50,000</span>
                    <span data-id="element-2614">Received: 3 days ago</span>
                  </div>
                </div>
                <div className="flex items-center mt-3 md:mt-0" data-id="element-2615">
                  <Button variant="primary" size="sm" className="mr-2" data-id="element-2616">
                    <Link to="/dashboard/rating-assessment" data-id="element-2617">
                      Begin Assessment
                    </Link>
                  </Button>
                  {expandedApplication === 'MS2023-103' ? <ChevronUpIcon className="w-5 h-5 text-neutral-400" data-id="element-2618" /> : <ChevronDownIcon className="w-5 h-5 text-neutral-400" data-id="element-2619" />}
                </div>
              </div>
              {expandedApplication === 'MS2023-103' && <div className="border-t border-neutral-100 p-4 bg-neutral-50" data-id="element-2620">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2621">
                    <div data-id="element-2622">
                      <h4 className="font-medium mb-3" data-id="element-2623">Business Information</h4>
                      <div className="space-y-3" data-id="element-2624">
                        <div className="flex justify-between" data-id="element-2625">
                          <span className="text-sm text-neutral-400" data-id="element-2626">
                            Business Name
                          </span>
                          <span className="text-sm font-medium" data-id="element-2627">
                            GreenTech Solutions
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2628">
                          <span className="text-sm text-neutral-400" data-id="element-2629">
                            Registration No.
                          </span>
                          <span className="text-sm font-medium" data-id="element-2630">
                            BRN-7654321-B
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2631">
                          <span className="text-sm text-neutral-400" data-id="element-2632">
                            Years in Operation
                          </span>
                          <span className="text-sm font-medium" data-id="element-2633">
                            4 years, 2 months
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2634">
                          <span className="text-sm text-neutral-400" data-id="element-2635">
                            Monthly Revenue
                          </span>
                          <span className="text-sm font-medium" data-id="element-2636">RM 65,000</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2637">
                          <span className="text-sm text-neutral-400" data-id="element-2638">
                            Credit Score
                          </span>
                          <span className="text-sm font-medium text-success" data-id="element-2639">
                            Very Good (80/100)
                          </span>
                        </div>
                      </div>
                    </div>
                    <div data-id="element-2640">
                      <h4 className="font-medium mb-3" data-id="element-2641">Financing Request</h4>
                      <div className="space-y-3" data-id="element-2642">
                        <div className="flex justify-between" data-id="element-2643">
                          <span className="text-sm text-neutral-400" data-id="element-2644">
                            Purpose
                          </span>
                          <span className="text-sm font-medium" data-id="element-2645">
                            Inventory Financing
                          </span>
                        </div>
                        <div className="flex justify-between" data-id="element-2646">
                          <span className="text-sm text-neutral-400" data-id="element-2647">
                            Amount Requested
                          </span>
                          <span className="text-sm font-medium" data-id="element-2648">RM 50,000</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2649">
                          <span className="text-sm text-neutral-400" data-id="element-2650">
                            Duration
                          </span>
                          <span className="text-sm font-medium" data-id="element-2651">9 months</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2652">
                          <span className="text-sm text-neutral-400" data-id="element-2653">
                            Monthly Payment
                          </span>
                          <span className="text-sm font-medium" data-id="element-2654">RM 5,889</span>
                        </div>
                        <div className="flex justify-between" data-id="element-2655">
                          <span className="text-sm text-neutral-400" data-id="element-2656">
                            Total Profit
                          </span>
                          <span className="text-sm font-medium" data-id="element-2657">
                            RM 6,750 (18% p.a.)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
            {/* Application Item 3 */}
            <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-2658">
              <div className="flex flex-col md:flex-row md:items-center justify-between p-4 cursor-pointer hover:bg-neutral-50" onClick={() => toggleApplicationDetails('MS2023-102')} data-id="element-2659">
                <div className="flex-1" data-id="element-2660">
                  <div className="flex items-center mb-2" data-id="element-2661">
                    <h3 className="font-medium mr-2" data-id="element-2662">Modest Fashion House</h3>
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs" data-id="element-2663">
                      Pending Assessment
                    </span>
                  </div>
                  <div className="text-sm text-neutral-400 flex flex-wrap gap-x-4" data-id="element-2664">
                    <span data-id="element-2665">ID: MS2023-102</span>
                    <span data-id="element-2666">Expansion</span>
                    <span data-id="element-2667">RM 80,000</span>
                    <span data-id="element-2668">Received: 5 days ago</span>
                  </div>
                </div>
                <div className="flex items-center mt-3 md:mt-0" data-id="element-2669">
                  <Button variant="primary" size="sm" className="mr-2" data-id="element-2670">
                    <Link to="/dashboard/rating-assessment" data-id="element-2671">
                      Begin Assessment
                    </Link>
                  </Button>
                  {expandedApplication === 'MS2023-102' ? <ChevronUpIcon className="w-5 h-5 text-neutral-400" data-id="element-2672" /> : <ChevronDownIcon className="w-5 h-5 text-neutral-400" data-id="element-2673" />}
                </div>
              </div>
            </div>
            {/* Application Item 4 */}
            <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-2674">
              <div className="flex flex-col md:flex-row md:items-center justify-between p-4 cursor-pointer hover:bg-neutral-50" onClick={() => toggleApplicationDetails('MS2023-101')} data-id="element-2675">
                <div className="flex-1" data-id="element-2676">
                  <div className="flex items-center mb-2" data-id="element-2677">
                    <h3 className="font-medium mr-2" data-id="element-2678">Halal Delights</h3>
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs" data-id="element-2679">
                      Pending Assessment
                    </span>
                  </div>
                  <div className="text-sm text-neutral-400 flex flex-wrap gap-x-4" data-id="element-2680">
                    <span data-id="element-2681">ID: MS2023-101</span>
                    <span data-id="element-2682">Equipment</span>
                    <span data-id="element-2683">RM 35,000</span>
                    <span data-id="element-2684">Received: 1 week ago</span>
                  </div>
                </div>
                <div className="flex items-center mt-3 md:mt-0" data-id="element-2685">
                  <Button variant="primary" size="sm" className="mr-2" data-id="element-2686">
                    <Link to="/dashboard/rating-assessment" data-id="element-2687">
                      Begin Assessment
                    </Link>
                  </Button>
                  {expandedApplication === 'MS2023-101' ? <ChevronUpIcon className="w-5 h-5 text-neutral-400" data-id="element-2688" /> : <ChevronDownIcon className="w-5 h-5 text-neutral-400" data-id="element-2689" />}
                </div>
              </div>
            </div>
            {/* Application Item 5 */}
            <div className="border border-neutral-200 rounded-lg overflow-hidden" data-id="element-2690">
              <div className="flex flex-col md:flex-row md:items-center justify-between p-4 cursor-pointer hover:bg-neutral-50" onClick={() => toggleApplicationDetails('MS2023-100')} data-id="element-2691">
                <div className="flex-1" data-id="element-2692">
                  <div className="flex items-center mb-2" data-id="element-2693">
                    <h3 className="font-medium mr-2" data-id="element-2694">Tech Innovate</h3>
                    <span className="bg-warning bg-opacity-10 text-warning px-2 py-1 rounded-full text-xs" data-id="element-2695">
                      Pending Assessment
                    </span>
                  </div>
                  <div className="text-sm text-neutral-400 flex flex-wrap gap-x-4" data-id="element-2696">
                    <span data-id="element-2697">ID: MS2023-100</span>
                    <span data-id="element-2698">R&D</span>
                    <span data-id="element-2699">RM 60,000</span>
                    <span data-id="element-2700">Received: 2 weeks ago</span>
                  </div>
                </div>
                <div className="flex items-center mt-3 md:mt-0" data-id="element-2701">
                  <Button variant="primary" size="sm" className="mr-2" data-id="element-2702">
                    <Link to="/dashboard/rating-assessment" data-id="element-2703">
                      Begin Assessment
                    </Link>
                  </Button>
                  {expandedApplication === 'MS2023-100' ? <ChevronUpIcon className="w-5 h-5 text-neutral-400" data-id="element-2704" /> : <ChevronDownIcon className="w-5 h-5 text-neutral-400" data-id="element-2705" />}
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Rating Methodology */}
      <section className="mb-8" data-id="element-2706">
        <h2 className="text-xl font-bold mb-4" data-id="element-2707">Rating Methodology</h2>
        <Card data-id="element-2708">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2709">
            <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-2710">
              <div className="flex items-center mb-3" data-id="element-2711">
                <div className="w-8 h-8 rounded-full bg-success bg-opacity-10 flex items-center justify-center mr-2" data-id="element-2712">
                  <TrendingDownIcon className="w-4 h-4 text-success" data-id="element-2713" />
                </div>
                <h4 className="font-medium" data-id="element-2714">Low Risk (A)</h4>
              </div>
              <ul className="space-y-2 text-sm" data-id="element-2715">
                <li className="flex items-center" data-id="element-2716">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-2717" />
                  <span data-id="element-2718">3+ years in business</span>
                </li>
                <li className="flex items-center" data-id="element-2719">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-2720" />
                  <span data-id="element-2721">Strong credit history (80+ score)</span>
                </li>
                <li className="flex items-center" data-id="element-2722">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-2723" />
                  <span data-id="element-2724">Debt-to-income ratio &lt; 30%</span>
                </li>
                <li className="flex items-center" data-id="element-2725">
                  <CheckCircleIcon className="w-4 h-4 text-success mr-2 flex-shrink-0" data-id="element-2726" />
                  <span data-id="element-2727">Profit margin &gt; 20%</span>
                </li>
              </ul>
              <div className="mt-3 text-xs text-neutral-500" data-id="element-2728">
                Profit rate: 12-14% p.a.
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-2729">
              <div className="flex items-center mb-3" data-id="element-2730">
                <div className="w-8 h-8 rounded-full bg-warning bg-opacity-10 flex items-center justify-center mr-2" data-id="element-2731">
                  <TrendingUpIcon className="w-4 h-4 text-warning" data-id="element-2732" />
                </div>
                <h4 className="font-medium" data-id="element-2733">Medium Risk (B)</h4>
              </div>
              <ul className="space-y-2 text-sm" data-id="element-2734">
                <li className="flex items-center" data-id="element-2735">
                  <CheckCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-2736" />
                  <span data-id="element-2737">2-3 years in business</span>
                </li>
                <li className="flex items-center" data-id="element-2738">
                  <CheckCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-2739" />
                  <span data-id="element-2740">Good credit history (65-80 score)</span>
                </li>
                <li className="flex items-center" data-id="element-2741">
                  <CheckCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-2742" />
                  <span data-id="element-2743">Debt-to-income ratio 30-50%</span>
                </li>
                <li className="flex items-center" data-id="element-2744">
                  <CheckCircleIcon className="w-4 h-4 text-warning mr-2 flex-shrink-0" data-id="element-2745" />
                  <span data-id="element-2746">Profit margin 10-20%</span>
                </li>
              </ul>
              <div className="mt-3 text-xs text-neutral-500" data-id="element-2747">
                Profit rate: 15-18% p.a.
              </div>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg" data-id="element-2748">
              <div className="flex items-center mb-3" data-id="element-2749">
                <div className="w-8 h-8 rounded-full bg-error bg-opacity-10 flex items-center justify-center mr-2" data-id="element-2750">
                  <AlertCircleIcon className="w-4 h-4 text-error" data-id="element-2751" />
                </div>
                <h4 className="font-medium" data-id="element-2752">High Risk (C)</h4>
              </div>
              <ul className="space-y-2 text-sm" data-id="element-2753">
                <li className="flex items-center" data-id="element-2754">
                  <CheckCircleIcon className="w-4 h-4 text-error mr-2 flex-shrink-0" data-id="element-2755" />
                  <span data-id="element-2756">Less than 2 years in business</span>
                </li>
                <li className="flex items-center" data-id="element-2757">
                  <CheckCircleIcon className="w-4 h-4 text-error mr-2 flex-shrink-0" data-id="element-2758" />
                  <span data-id="element-2759">Fair credit history (below 65 score)</span>
                </li>
                <li className="flex items-center" data-id="element-2760">
                  <CheckCircleIcon className="w-4 h-4 text-error mr-2 flex-shrink-0" data-id="element-2761" />
                  <span data-id="element-2762">Debt-to-income ratio &gt; 50%</span>
                </li>
                <li className="flex items-center" data-id="element-2763">
                  <CheckCircleIcon className="w-4 h-4 text-error mr-2 flex-shrink-0" data-id="element-2764" />
                  <span data-id="element-2765">Profit margin &lt; 10%</span>
                </li>
              </ul>
              <div className="mt-3 text-xs text-neutral-500" data-id="element-2766">
                Profit rate: 19-22% p.a. or not eligible
              </div>
            </div>
          </div>
          <div className="mt-6 p-4 bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg" data-id="element-2767">
            <div className="flex items-center mb-2" data-id="element-2768">
              <BarChart3Icon className="w-5 h-5 text-primary mr-2" data-id="element-2769" />
              <h4 className="font-medium text-primary" data-id="element-2770">Rating Performance</h4>
            </div>
            <p className="text-sm text-neutral-500 mb-3" data-id="element-2771">
              Our rating methodology has demonstrated 95% accuracy in predicting
              repayment performance over the past 12 months. The default rate
              for A-rated micro-sukuk is 0.8%, B-rated is 3.2%, and C-rated is
              8.5%.
            </p>
            <Button variant="outline" size="sm" className="border-primary text-primary" data-id="element-2772">
              View Full Methodology
            </Button>
          </div>
        </Card>
      </section>
    </div>;
};
export default RatingAgencyPortal;